import { Location } from "@angular/common";
import {
  Component,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChange,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, NgForm } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "src/app/core/service/auth.service";
import { EncryptDecryptParametersServiceService } from "src/app/core/service/encrypt-decrypt-parameters-service.service";
import { CreateComponent } from "src/app/doctor/patient/list/components/create/create.component";
import { ViewComponent } from "src/app/doctor/patient/list/components/create/view/view.component";
import { PaginationVM } from "src/app/shared/models/pagination-vm";
import { Patient } from "src/app/shared/models/patients";
import { Prescription } from "src/app/shared/models/prescription";
import { PrescriptionPageObject } from "src/app/shared/models/prescription-page-object";
import { PrescriptionPatientVM } from "src/app/shared/models/PrescriptionPatientVM";
import { UserAccount } from "src/app/shared/models/user-account";
import { NotificationService } from "src/app/shared/notification.service";
import { PrescriptionService } from "../../prescription.service";
import { MatSort } from "@angular/material/sort";
import { userRole } from "src/app/shared/userRole";
import { ActivityType } from "src/app/shared/ActivityType";
import { AppService } from "src/app/core/service/app.service";
import { UserIdleService } from "angular-user-idle";

@Component({
  selector: "app-prescription",
  templateUrl: "./prescriptions.component.html",
  styleUrls: ["./prescriptions.component.sass"],
})
export class PrescriptionsComponent implements OnInit, OnDestroy {
  @ViewChild("DeletePrescriptionComponent")
  DeletePrescriptionComponent: TemplateRef<any>;
  @ViewChild("UpdatePrescriptionComponent")
  UpdatePrescriptionComponent: TemplateRef<any>;
  @ViewChild("EditPrescriptionComponent")
  EditPrescriptionComponent: TemplateRef<any>;
  @ViewChild("ClonePrescriptionComponent")
  ClonePrescriptionComponent: TemplateRef<any>;
  @ViewChild("CancelPrescriptionComponent")
  CancelPrescriptionComponent: TemplateRef<any>;
  // @ViewChild("DeletePatientComponent") DeleteComponent: TemplateRef<any>;
  displayedColumns = [
    "Profile",
    "Name",
    "No",
    "CreatedDate",
    "Medicine#",
    "Status",
    "actions",
  ];
  @Input() prescriptionPageObject: PrescriptionPageObject = {
    Title: "PRESCRIPTIONS",
    ColumnList: [
      "Profile",
      "Name",
      "No",
      "CreatedDate",
      "Medicine#",
      "Status",
      "actions",
    ],
    PageCriteria: [],
    Role: "",
    SearchCriteria: {
      UserRoleId: null,
      PageNumber: 1,
      PageSize: 10,
      TotalCount: 0,
      Filter: {
        IsActive: true,
        patientFirstName: null,
        patientLastName: null,
        prescriptionNo: null,
        doctorAccountId: 0,
        status: null,
        sortBy: null,
        sortOrder: null,
      },
      Records: new Array<PrescriptionPatientVM>(),
      SortBy: "CreatedDate",
      SortOrder: false,
      UserRole: null,
      RolePrefix: null,
    },
    ShowFilter: true,
  };
  records: Array<PrescriptionPatientVM>;
  searchFilter = {
    patientFirstName: "",
    patientLastName: "",
    prescriptionNo: "",
    status: "",
    isReadyToCollect: -1,
  };
  index: number;
  id: any;
  prescription: Prescription;
  currentUser: UserAccount;
  paginationVM: PaginationVM<PrescriptionPatientVM>;
  pageEvent: PageEvent;
  searchPatientForm: FormGroup;
  finalURL: any;
  patient: Patient;
  pdfstring: any;
  dataSource: MatTableDataSource<PrescriptionPatientVM>;
  firstLastButtons = true;
  constructor(
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private prescriptionService: PrescriptionService,
    private dialogModel: MatDialog,
    private authService: AuthService,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private router: Router,
    private encryptDecryptParametersService: EncryptDecryptParametersServiceService,
    private location: Location,
    private notificationService: NotificationService,
    private _ngZone: NgZone,
    private appService: AppService,
  ) {
    this.currentUser = JSON.parse(sessionStorage.getItem("CurrentUser"));
    // if (this.currentUser.UserRoleId != 2) {
    //   this.displayedColumns.splice(-1, 1);
    // }
    // if (this.currentUser.UserRoleId != 2) {
    //   this.prescriptionPageObject.ColumnList.splice(-1, 1);
    // }
    this.paginationVM = <PaginationVM<PrescriptionPatientVM>>{
      UserRoleId: this.currentUser.UserRoleId,
      PageNumber: 1,
      PageSize: 10,
      TotalCount: 0,
      Filter: {
        IsActive: true,
        patientFirstName: "",
        patientLastName: "",
        prescriptionNo: "",
        doctorAccountId: this.currentUser.Id,
        status: null,
        isReadyToCollect: -1,
      },
      Records: new Array<PrescriptionPatientVM>(),
      SortBy: "CreatedDate",
      SortOrder: false,
    };
    this.records = new Array<PrescriptionPatientVM>();
    this.searchPatientForm = this.fb.group({
      patientFirstName: [""],
      patientLastName: [""],
      prescriptionNo: [""],
      status: [""],
      isReadyToCollect: [-1],
    });
    this.dataSource = new MatTableDataSource(this.records);
  }

  ngOnInit(): void {
    if (this.router.url.includes("?")) {
      const finalURL =
        this.router.url.split("?")[0] +
        "?" +
        this.encryptDecryptParametersService.decrypt(this.router.url);
      var data = JSON.parse(
        this.encryptDecryptParametersService.getQueryParams("details", finalURL)
      );
      if (data.Status != null) {
        this.paginationVM.Filter.status = data.Status;
        this.searchFilter.status = data.Status;
        this.searchPatientForm.get("status").setValue(data.Status);
      } else if (data.FirstName != null && data.LastName != null) {
        this.paginationVM.Filter.FirstName = data.FirstName;
        this.paginationVM.Filter.LastName = data.LastName;
        this.searchPatientForm.get("patientFirstName").setValue(data.FirstName);
        this.searchPatientForm.get("patientLastName").setValue(data.LastName);
        this.searchFilter.patientFirstName = data.FirstName;
        this.searchFilter.patientLastName = data.LastName;
      }
    }
    this.getPrescriptionList();
    this.subscribeToEvents();
  }
  reset() {
    this.paginationVM = <PaginationVM<PrescriptionPatientVM>>{
      UserRoleId: this.currentUser.UserRoleId,
      PageNumber: 1,
      PageSize: 10,
      TotalCount: 0,
      Filter: {
        IsActive: true,
        patientName: "",
        prescriptionNo: "",
        doctorAccountId: this.currentUser.Id,
        status: null,
        isReadyToCollect: -1,
      },
      Records: new Array<PrescriptionPatientVM>(),
      SortBy: "CreatedDate",
      SortOrder: false,
    };
    this.searchFilter.status = "";
    this.searchFilter.prescriptionNo = null;
    this.searchFilter.patientFirstName = null;
    this.searchFilter.patientLastName = null;
    this.searchFilter.isReadyToCollect = -1;
    this.paginationVM.Filter.status = this.searchFilter.status;
    this.searchPatientForm.reset();
    this.searchPatientForm.get("status").setValue("");
    this.searchPatientForm.get("isReadyToCollect").setValue(-1);
    this.getPrescriptionList();
  }

  deletePrescription() {
    var prescriptionId = {
      prescriptionDetails: this.prescription.Id,
    };
    this.spinner.show();
    this.prescriptionService.DeletePrescription(prescriptionId).subscribe({
      next: (resp: any) => {
        this.closeDialog();
        this.authService.showNotification(
          "snackbar-success",
          "Delete Record Successfully.",
          "top",
          "center"
        );
        this.getPrescriptionList();
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  closeDialog(): void {
    this.dialog.closeAll();
  }

  searchPrescription() {
    if (this.searchPatientForm.valid) {
      this.searchFilter.patientFirstName = this.searchPatientForm.get(
        "patientFirstName"
      ).value;
      this.searchFilter.patientLastName = this.searchPatientForm.get(
        "patientLastName"
      ).value;
      this.searchFilter.prescriptionNo = this.searchPatientForm.get(
        "prescriptionNo"
      ).value;
      this.searchFilter.status = this.searchPatientForm.get("status").value;
      this.searchFilter.isReadyToCollect = this.searchPatientForm.get(
        "isReadyToCollect"
      ).value;
      // if
      this.getPrescriptionList();
    }
  }

  removeSelectedRows() {}
  addNew() {}
  refresh() {}
  editCall(row) {}

  getPrescriptionList() {
    this.spinner.show();
    this.paginationVM.Filter.status =
      this.searchFilter.status == ""
        ? this.prescriptionPageObject.SearchCriteria.Filter.status
        : this.searchFilter.status;
    if (this.finalURL != "" && this.finalURL != undefined) {
      this.searchFilter.status = this.finalURL;
      this.paginationVM.Filter.status = this.finalURL;
    }
    this.paginationVM.Filter.patientFirstName = this.searchFilter.patientFirstName;
    this.paginationVM.Filter.patientLastName = this.searchFilter.patientLastName;
    this.paginationVM.Filter.prescriptionNo = this.searchFilter.prescriptionNo;
    this.paginationVM.Filter.isReadyToCollect = this.searchFilter.isReadyToCollect;
    if (
      this.currentUser.UserRoleId == userRole.pharmacist ||
      this.currentUser.UserRoleId == userRole.pharmacistSubAdmin
    ) {
      this.paginationVM.Filter.doctorAccountId = 0;
    }
    this.prescriptionService.GetPrescriptionList(this.paginationVM).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
          this.paginationVM = resp;
          this.records = this.paginationVM.Records;
          this.records.forEach((element) => {
            if (element.Prescription.Status == "FILLED") {
              element.Prescription.Class = "badge filled";
            } else if (element.Prescription.Status == "PARTIALLY FILLED") {
              element.Prescription.Class = "badge partially-filled";
            } else if (element.Prescription.Status == "IN PROGRESS") {
              element.Prescription.Class = "badge in-progress";
            } else if (element.Prescription.Status == "PENDING") {
              element.Prescription.Class = "badge pending";
            } else if (element.Prescription.Status == "CANCELLED") {
              element.Prescription.Class = "badge cancelled";
            }
          });
          this.spinner.hide();
        } else {
          this.authService.showNotification(
            "snackbar-danger",
            "something went wrong.",
            "top",
            "center"
          );
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  // openDeleteConfirmation(template, data) {
  //   const dialogRef = this.dialogModel.open(template, {
  //     width: "640px",
  //     disableClose: true,
  //   });
  // }

  // deleteItem(row) {
  //   const dialogRef = this.dialog.open(this.DeleteComponent, {
  //     data: row,
  //     maxWidth: "750px",
  //     disableClose: true,
  //   });
  // }

  deleteItem(i: number, row) {
    this.index = i;
    this.id = row.id;
    this.prescription = row?.Prescription;
    const dialogRef = this.dialog.open(this.DeletePrescriptionComponent, {
      data: row,
      maxWidth: "750px",
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 1) {
        // for delete we use splice in order to remove single object from DataService
        this.authService.showNotification(
          "snackbar-success",
          "Prescription deleted successfully.",
          "bottom",
          "center"
        );
        this.getPrescriptionList();
      }
    });
  }
  public handlePage(e: any) {
    this.paginationVM.PageNumber = e.pageIndex + 1;
    this.paginationVM.PageSize = e.pageSize;
    this.getPrescriptionList();
  }
  ngOnDestroy() {
    this.finalURL = "";
  }

  viewPatientCall(row) {
    this.id = row.id;
    this.patient = row.Patient;
    const dialogRef = this.dialog.open(ViewComponent, {
      data: {
        patient: row.Patient,
        action: "view",
      },
      maxWidth: "750px",
      disableClose: true,
    });
  }

  viewPrescription(row) {
    row.Prescription.OldStatus = row.Prescription.Status;
    // details.Prescription.Status = "INPROGRESS";
    const encryptedstring = this.encryptDecryptParametersService.encrypt(
      `details=${JSON.stringify({
        Id: row.Prescription.Id,
        Status: row.Prescription.OldStatus,
      })}`
    );
    this.router.navigateByUrl(
      `/pharmacist/prescription/view?${encryptedstring}`
    );
  }

  updateItem(i: number, row) {
    this.index = i;
    this.id = row.id;
    this.prescription = row?.Prescription;
    const dialogRef = this.dialog.open(this.UpdatePrescriptionComponent, {
      data: row,
      maxWidth: "750px",
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 1) {
        // for delete we use splice in order to remove single object from DataService
        this.authService.showNotification(
          "snackbar-success",
          "Delete Record Successfully.",
          "bottom",
          "center"
        );
        this.getPrescriptionList();
      }
    });
  }

  updatePrescription() {
    this.prescription.IsLock = false;
    var prescriptionDetails = {
      prescriptionDetails: this.prescription,
    };
    this.spinner.show();
    this.prescriptionService
      .UpdatePrescriptionObj(prescriptionDetails)
      .subscribe({
        next: (resp: any) => {
          if (!resp.HasErrors) {
            this.notificationService.SendPrescription(resp);
            this.closeDialog();
            if (this.prescription.Status == "CANCELLED") {
              this.AddUserActivity(
                this.currentUser.FirstName + " " + this.currentUser.LastName,
                this.currentUser.Id,
                ActivityType.CancelPrescription,
                "Cancel Prescription",
                "Prescription " +
                  this.prescription.PrescriptionNo +
                  " is cancelled by " +
                  this.currentUser.FirstName +
                  " " +
                  this.currentUser.LastName
              );
              this.authService.showNotification(
                "snackbar-success",
                "The prescription has been cancelled.",
                "top",
                "center"
              );
            } else {
              this.AddUserActivity(
                this.currentUser.FirstName + " " + this.currentUser.LastName,
                this.currentUser.Id,
                ActivityType.UnLockPrescription,
                "Unlock Prescription",
                "Prescription " +
                  this.prescription.PrescriptionNo +
                  " is unlocked by " +
                  this.currentUser.FirstName +
                  " " +
                  this.currentUser.LastName
              );
              this.authService.showNotification(
                "snackbar-success",
                "The prescription has been unlocked.",
                "top",
                "center"
              );
            }

            this.getPrescriptionList();
            this.spinner.hide();
          }
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  goBack() {
    this.location.back();
  }
  downloadPrescription(row: any) {
    this.spinner.show();
    var prescriptionDetails = {
      prescriptionDetails: row.Prescription.Id,
    };
    this.prescriptionService
      .DownloadPrescription(prescriptionDetails)
      .subscribe({
        next: (resp: any) => {
          if (!resp.HasErrors) {
            this.closeDialog();
            this.pdfstring = resp.pdf;
            this.downloadFile(this.pdfstring, "application/pdf", "download")
            this.AddUserActivity(
              this.currentUser.FirstName + " " + this.currentUser.LastName,
              this.currentUser.Id,
              ActivityType.DownloadPrescription,
              "Download Prescription",
              "Prescription " +
                row.Prescription.PrescriptionNo +
                " is downloaded by " +
                this.currentUser.FirstName +
                " " +
                this.currentUser.LastName
            );
            this.spinner.hide();
          } else {
            this.spinner.hide();
          }
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  downloadFile(data: string, fileType: any, type: string): void {
    const byteCharacters = atob(data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileType });
    const url = window.URL.createObjectURL(blob);
    if (type === "print") {
      window.location.href = url;
    } else {
      const downloadPDF = document.createElement("a");
      downloadPDF.href = url;
      this.printPDF(downloadPDF.href)
      downloadPDF.download = "Prescription_" + new Date() + ".pdf";
      downloadPDF.click();
    }
  }
  printPDF(url)
    {
        let pdfFrame = document.body.appendChild(document.createElement('iframe'));
        pdfFrame.style.display = 'none';
        pdfFrame.onload = () => (void pdfFrame.contentWindow.print());
        pdfFrame.src = url;
    }

  private subscribeToEvents(): void {
    this.notificationService.messageReceived.subscribe((resp: any) => {
      this._ngZone.run(() => {
        var prescription: Prescription;
        prescription = new Prescription();
        prescription = resp;
        if (prescription.Status == "FILLED") {
          prescription.Class = "badge filled";
        } else if (prescription.Status == "PARTIALLY FILLED") {
          prescription.Class = "badge partially-filled";
        } else if (prescription.Status == "IN PROGRESS") {
          prescription.Class = "badge in-progress";
        } else if (prescription.Status == "PENDING") {
          prescription.Class = "badge pending";
        } else if (prescription.Status == "CANCELLED") {
          prescription.Class = "badge cancelled";
        }
        if (
          (prescription.Status == "PENDING" ||
            prescription.Status == "FILLED" ||
            prescription.Status == "PARTIALLY FILLED" ||
            prescription.Status == "IN PROGRESS") &&
          this.records != undefined
        ) {
          if (this.records.length != 0) {
            this.records.forEach((element) => {
              if (element.Prescription.Id == prescription.Id) {
                let i = this.records.indexOf(element);
                this.records[i].Prescription = prescription;
              }
            });
          }
        }
      });
    });
  }

  EditItem(i: number, row) {
    if (
      row?.Prescription.Status == "PENDING" ||
      row?.Prescription.Status == "IN PROGRESS"
    ) {
      this.index = i;
      this.id = row.id;
      this.prescription = row?.Prescription;
      this.RedirectTOFill();
    } else {
      this.index = i;
      this.id = row.id;
      this.prescription = row?.Prescription;
      const dialogRef = this.dialog.open(this.EditPrescriptionComponent, {
        data: row,
        maxWidth: "750px",
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 1) {
          // for delete we use splice in order to remove single object from DataService
          // this.authService.showNotification(
          //   "snackbar-success",
          //   "Edited Record Successfully.",
          //   "bottom",
          //   "center"
          // );
          // this.getPrescriptionList();
        }
      });
    }
  }

  RedirectTOFill() {
    this.closeDialog();
    this.prescription.IsLock = true;
    this.prescription.IsLockBy = this.currentUser.Id;
    this.ChangePrescriptionStatus(this.prescription);
  }

  CloneItem(i: number, row) {
    this.index = i;
    this.id = row.id;
    this.prescription = row?.Prescription;
    const dialogRef = this.dialog.open(this.ClonePrescriptionComponent, {
      data: row,
      maxWidth: "750px",
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 1) {
        // for delete we use splice in order to remove single object from DataService
        // this.authService.showNotification(
        //   "snackbar-success",
        //   "Edited Record Successfully.",
        //   "bottom",
        //   "center"
        // );
        // this.getPrescriptionList();
      }
    });
  }

  ClonePrescription() {
    this.closeDialog();
    const encryptedstring = this.encryptDecryptParametersService.encrypt(
      `details=${JSON.stringify({
        Id: this.prescription.Id,
      })}`
    );
    this.router.navigateByUrl(
      `/pharmacist/prescription/create?${encryptedstring}`
    );
  }

  sortBy(sortBy) {
    this.paginationVM.SortOrder = !this.paginationVM.SortOrder;
    this.paginationVM.SortBy = sortBy;
    this.getPrescriptionList();
  }

  ChangePrescriptionStatus(prescriptionDetails) {
    var changedStatus = {
      // prescriptionId: prescriptionDetails.Id,
      // newStatus: "IN PROGRESS",
      // isLock: prescriptionDetails.IsLock,
      // isLockBy: prescriptionDetails.IsLockBy,
      // isPrinted:true
      "prescriptionDetails":{}
    };
    changedStatus.prescriptionDetails={
      "Id":prescriptionDetails.Id,
      "Status":"IN PROGRESS",
      "IsLock":prescriptionDetails.IsLock,
      "IsLockBy":prescriptionDetails.IsLockBy,
      "IsPrinted":true
    }

    this.spinner.show();
    debugger
    this.prescriptionService.ChangePrescriptionStatus(changedStatus).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
          prescriptionDetails.Prescription = resp;
          this.spinner.hide();
          this.notificationService.SendPrescription(
            prescriptionDetails.Prescription
          );
          const encryptedstring = this.encryptDecryptParametersService.encrypt(
            `details=${JSON.stringify({
              Id: this.prescription.Id,
              Status: this.prescription.Status,
            })}`
          );
          this.router.navigateByUrl(
            `/pharmacist/prescription/fill?${encryptedstring}`
          );
        } else {
          this.authService.showNotification(
            "snackbar-danger",
            "something went wrong.",
            "top",
            "center"
          );
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  CancelPrescription() {
    this.prescription.Status = "CANCELLED";
    this.updatePrescription();
  }

  CancelItem(i: number, row) {
    this.index = i;
    this.id = row.id;
    this.prescription = row?.Prescription;
    const dialogRef = this.dialog.open(this.CancelPrescriptionComponent, {
      data: row,
      maxWidth: "750px",
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 1) {
        // for delete we use splice in order to remove single object from DataService
        this.authService.showNotification(
          "snackbar-success",
          "Prescription cancelled successfully.",
          "bottom",
          "center"
        );
        this.getPrescriptionList();
      }
    });
  }

  AddUserActivity(
    username,
    userAccountId,
    activityType,
    activityName,
    description
  ) {
    var userActivity = {
      ActivityType: activityType,
      ActivityName: activityName,
      UserName: username,
      Description: description,
      UserAccountId: userAccountId,
    };
    this.appService.AddUserActivity(userActivity).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
        }
      },
      error: () => {},
    });
  }
}
